import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle, Loader } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useJazyk } from '../context/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmailPage() {
  const { t } = useJazyk();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage(t('over.neplatnyOdkaz'));
      return;
    }
    let cancelled = false;
    axios.get(`${API}/auth/verify-email/${token}`)
      .then(r => {
        if (!cancelled) {
          setStatus('success');
          setMessage(t('over.hotovo'));
        }
      })
      .catch(e => {
        if (!cancelled) {
          setStatus('error');
          setMessage(t('over.odkazVyprsel'));
        }
      });
    return () => { cancelled = true; };
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-bloom-bg flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-border/50 p-8 text-center">
        <div className="h-1 bg-gradient-to-r from-[#5BCEFA] via-[#F5A9B8] to-[#5BCEFA] rounded-full mb-8" />
        
        {status === 'loading' && (
          <div>
            <Loader className="w-12 h-12 text-bloom-violet mx-auto mb-4 animate-spin" />
            <h2 className="font-serif text-xl font-semibold text-bloom-text mb-2">{t('over.overuji')}</h2>
            <p className="text-bloom-sub text-sm">{t('over.cekejte')}</p>
          </div>
        )}

        {status === 'success' && (
          <div>
            <CheckCircle className="w-14 h-14 text-bloom-mint mx-auto mb-4" />
            <h2 className="font-serif text-2xl font-bold text-bloom-text mb-2">{t('over.overen')}</h2>
            <p className="text-bloom-sub mb-6">{message}</p>
            <p className="text-bloom-sub text-sm mb-6">{t('over.plnyPristup')}</p>
            <Button
              className="bg-bloom-violet text-white hover:bg-bloom-violet/90 w-full"
              onClick={() => navigate('/')}
              data-testid="go-home-btn"
            >
              {t('over.prejitNaBloom')}
            </Button>
          </div>
        )}

        {status === 'error' && (
          <div>
            <XCircle className="w-14 h-14 text-destructive mx-auto mb-4" />
            <h2 className="font-serif text-2xl font-bold text-bloom-text mb-2">{t('over.selhalo')}</h2>
            <p className="text-bloom-sub mb-6">{message}</p>
            <Button
              variant="outline"
              className="w-full border-bloom-violet/30 text-bloom-violet"
              onClick={() => navigate('/auth')}
            >
              {t('over.zpetNaPrihlaseni')}
            </Button>
          </div>
        )}

        <div className="h-1 bg-gradient-to-r from-[#5BCEFA] via-[#F5A9B8] to-[#5BCEFA] rounded-full mt-8" />
      </div>
    </div>
  );
}
